var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "../valueObjects/guid"], function (require, exports, guid_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ToastNotification = void 0;
    guid_1 = __importDefault(guid_1);
    var ToastClassConfig = (function () {
        function ToastClassConfig() {
            this.Alert = 'bg-orange-500';
            this.Error = 'bg-red-500';
            this.Success = 'bg-green-500';
        }
        return ToastClassConfig;
    }());
    var ToastNotification = (function () {
        function ToastNotification() {
        }
        ToastNotification.CreateLabel = function () {
            var guid = new guid_1.default();
            var div = document.createElement('div');
            div.id = guid.toString();
            div.classList.add('hidden', 'alert-toast', 'flex', 'float-right', 'm-8', 'float-right', 'pointer-events-auto');
            div.style.zIndex = '9999';
            var lbl = document.createElement('label');
            lbl.classList.add('close', 'cursor-pointer', 'items-start', 'justify-between', 'w-full', 'py-6', 'px-2', 'bg-red-500', 'shadow-lg', 'text-white', 'text-sm');
            lbl.setAttribute('for', 'footertoast');
            lbl.title = 'Fechar';
            div.appendChild(lbl);
            return lbl;
        };
        ToastNotification.GetLabel = function () {
            return this.CreateLabel();
        };
        ToastNotification.GetDivToasts = function () {
            return document.getElementById(this._divToasts);
        };
        ToastNotification.Alert = function (text, timeoutMs) {
            if (timeoutMs === void 0) { timeoutMs = 10000; }
            var lbl = this.GetLabel();
            if (!lbl)
                return;
            var config = this.GetConfig();
            lbl.classList.remove(config.Error);
            lbl.classList.remove(config.Success);
            lbl.classList.add(config.Alert);
            console.warn(text);
            this.SetLabel(lbl, text, timeoutMs, this._type.alert);
        };
        ToastNotification.Error = function (text, timeoutMs, hideOthers) {
            if (timeoutMs === void 0) { timeoutMs = 10000; }
            if (hideOthers === void 0) { hideOthers = false; }
            var lbl = this.GetLabel();
            if (!lbl)
                return;
            var config = this.GetConfig();
            lbl.classList.remove(config.Alert);
            lbl.classList.remove(config.Success);
            lbl.classList.add(config.Error);
            console.error(text);
            this.SetLabel(lbl, text, timeoutMs, this._type.error, hideOthers);
        };
        ToastNotification.Success = function (text, timeoutMs) {
            if (timeoutMs === void 0) { timeoutMs = 10000; }
            var lbl = this.GetLabel();
            if (!lbl)
                return;
            var config = this.GetConfig();
            lbl.classList.remove(config.Alert);
            lbl.classList.remove(config.Error);
            lbl.classList.add(config.Success);
            console.info(text);
            this.SetLabel(lbl, text, timeoutMs, this._type.success);
        };
        ToastNotification.SetLabel = function (lbl, text, timeoutMs, type, hideOthers) {
            var _this = this;
            if (hideOthers === void 0) { hideOthers = false; }
            var parent = lbl === null || lbl === void 0 ? void 0 : lbl.parentElement;
            var divToasts = this.GetDivToasts();
            if (!lbl || !parent || !divToasts)
                return;
            var sameToast = this.GetToastSameText(text, type);
            if (!sameToast || hideOthers) {
                if (hideOthers)
                    Array.from(divToasts.children).forEach(function (elem) {
                        elem.remove();
                    });
                lbl.innerText = text;
                lbl.addEventListener('click', function (e) { _this.DestroyToast(e, parent); });
                divToasts.appendChild(parent);
                parent.classList.remove('hidden');
                parent.setAttribute(this._refreshAttr, "false");
                this.SetToastType(parent, type);
                if (timeoutMs) {
                    this.HideAfter(lbl, timeoutMs);
                }
            }
            else {
                parent.remove();
                var oldParent = sameToast.parentElement;
                oldParent.setAttribute(this._refreshAttr, "true");
                oldParent.classList.remove('hidden');
            }
        };
        ToastNotification.SetToastType = function (div, type) {
            div.setAttribute(this._typeAttr, "" + type);
        };
        ToastNotification.GetToastType = function (div) {
            return Number(div.getAttribute(this._typeAttr));
        };
        ToastNotification.GetToastSameText = function (text, msgType) {
            var toasts = this.GetDivToasts();
            if (!toasts)
                return null;
            var list = Array.from(toasts.children);
            for (var c = 0; c < list.length; c++) {
                var div = list[c];
                if (!div)
                    continue;
                var type = this.GetToastType(div);
                if (msgType != type)
                    continue;
                var lbl = Array.from(div.getElementsByTagName('label'));
                if (!lbl)
                    continue;
                var res = lbl.filter(function (x) {
                    return x.innerText == text;
                });
                if (!res || res.length === 0)
                    continue;
                return res[0];
            }
            return null;
        };
        ToastNotification.HideAfter = function (lbl, timeoutMs) {
            var _this = this;
            if (!lbl)
                return;
            setTimeout(function () {
                if (!lbl.parentElement) {
                    lbl.remove();
                    return;
                }
                var parent = document.getElementById(lbl.parentElement.id);
                if (!parent) {
                    lbl.remove();
                    return;
                }
                var refreshed = parent.getAttribute(_this._refreshAttr);
                if (refreshed === 'true') {
                    parent.setAttribute(_this._refreshAttr, 'false');
                    _this.HideAfter(lbl, timeoutMs);
                }
                else
                    _this.Hide(lbl);
            }, timeoutMs);
        };
        ToastNotification.Hide = function (lbl) {
            if (!lbl)
                return;
            lbl.dispatchEvent(new Event('click'));
        };
        ToastNotification.DestroyToast = function (e, lblParent) {
            var _this = this;
            if (!lblParent)
                return;
            lblParent.classList.add('hidden');
            setTimeout(function () {
                if (lblParent.classList.contains('hidden'))
                    lblParent.remove();
                else
                    _this.DestroyToast(e, lblParent);
            }, 1000);
        };
        ToastNotification._divToasts = 'div-toasts';
        ToastNotification._typeAttr = 'data-toast-type';
        ToastNotification._refreshAttr = 'data-toast-refreshed';
        ToastNotification._type = {
            success: 1,
            alert: 2,
            error: 3
        };
        ToastNotification.GetConfig = function () {
            return new ToastClassConfig();
        };
        return ToastNotification;
    }());
    exports.ToastNotification = ToastNotification;
});
